import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const ArrowDownIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M34.8577778,2.01888853 L2.13,33.0433274 C-0.71,35.7366602 -0.71,40.1011039 2.13,42.7944367 C4.97,45.4866585 9.57666667,45.4866585 12.4155556,42.7944367 L32.6044444,23.6555513 L32.4888889,72.9633202 L32.4888889,72.9788757 C32.4888889,74.8399865 33.2311111,76.5955418 34.5811111,77.9244304 C35.9355556,79.2577635 37.73,79.99443 39.6322222,79.9988745 L40.0511111,79.9999856 C43.9988889,80.0077634 47.2177778,76.8655417 47.2266667,72.9966535 L47.3422222,23.6044402 L67.5855556,42.7944367 C70.4244444,45.4866585 75.0311111,45.4866585 77.87,42.7944367 C80.71,40.1011039 80.71,35.7366602 77.87,33.0433274 L45.1433333,2.01888853 C43.7233333,0.673333212 41.8622222,0 40,0 C38.1388889,0 36.2777778,0.673333212 34.8577778,2.01888853"
        transform="rotate(180 40 40)"
      />
    </Icon>
  );
};

ArrowDownIcon.propTypes = {
  fill: PropTypes.string,
};

export default ArrowDownIcon;
